import React from 'react';
import $ from 'jquery';
import { refDelete, refRestore } from './simple.store';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { ReactBootstrapTableRemotePagination } from
  '@/component/form/ReactBootstrapTableRemotePagination.jsx';
import { Glyphicon, Modal, Col } from 'react-bootstrap';
import {
  Button,
} from '../../form/FormControls.jsx';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import { MainComponentBox, UrlWrappedLink, LinkLikeButton,
  TableOptions, locationFallThroughInitial } from '../../../util/util.jsx';
import { getSimpleListWrapper } from './SimpleWrapper.js';
import RoleConfigFilter, { validateRoleConfig } from '@/component/auth/RoleConfigFilter.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';
import { Audit } from '@/component/blogic/deals/audit/Audit.jsx';
import trash from '../../../../style/trash.png';
import audit from '../../../../style/audit.png';
import pencil from '../../../../style/pencil.png';
import { navTo } from '@/util/util';
import { getTextFilter } from '../../form/ReactBootstrapTableTextFilter';

function mapRefPath(data, refPath, showHidden = false) {
  return data ? data
    .filter(x => (showHidden ? true : !x.get('hidden')))
    .map(x => x.set('refPath', refPath))
    .map(x => x.toJS())
    .toArray() : undefined;
}

export const mapDispatchToProps = (refName, refPath) => (dispatch) => ({
  deleteRef: (data) => {
    refDelete(dispatch, `${refName}`, `${refPath}`, data);
  },
  restore: (id) => refRestore(dispatch, `${refName}`, `${refPath}`, id),
});

export class List extends React.Component {
  constructor(props) {
    super(props);
    this.renderModificationButtons = this.renderModificationButtons.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.showHiddenToggle = this.showHiddenToggle.bind(this);
    this.state = { showModal: false, id: undefined, showHidden: false };
  }
  componentWillMount() {
    getSimpleListWrapper(this.refName, this.refPath);
    locationFallThroughInitial(this.name, `/references/${this.refPath}`);
    this.setNewRefs(this.props);
  }
  componentWillReceiveProps(props) {
    getSimpleListWrapper(this.refName, this.refPath);
    this.setNewRefs(props);
  }

  setNewRefs(props) {
    if (props.refs) {
      this.setState({ refs: mapRefPath(props.refs, this.refPath, this.state.showHidden) });
    }
  }
  setName(name) {
    this.name = name;
  }

  setRefPath(refPath) {
    this.refPath = refPath;
  }
  setRefName(refName) {
    this.refName = refName;
  }

  getNameColumn = () => <TableHeaderColumn
    dataField="name" dataSort
    className={'references-name-header'}
    columnClassName={'references-name-row'}
    filter={{ type: 'CustomFilter',
      getElement: getTextFilter,
      customFilterParameters: { columnName: `${this.name} name` },
    }}
  >
    {this.name ? `${this.name} name` : 'Name'}
  </TableHeaderColumn>

  restore(id) {
    this.props.restore(id);
  }
  showHiddenToggle() {
    this.setState({ showHidden: !this.state.showHidden,
      refs: mapRefPath(this.props.refs, this.refPath, !this.state.showHidden) });
  }

  openModal(id) {
    this.setState({ showModal: true, id });
  }
  closeModal() {
    this.setState({ showModal: false, id: undefined });
  }
  yesButton() {
    this.props.deleteRef(this.state.id);
    this.setState({ showModal: false, id: undefined });
  }


  showAddButton() {
    return validateRoleConfig(['references#2']);
  }

  renderModificationButtons(id, ref) {
    return (<div className={'reference-mod-column'}>
      <RoleConfigFilter permissions={['references#3']}>
        {ref.hidden ?
          <LinkLikeButton onClick={() => this.restore(id)}>
            <Glyphicon
              title="Restore" id={`restore_${id}`} glyph="repeat"
            />
          </LinkLikeButton>
          :
          !ref.predefine &&
            <LinkLikeButton onClick={() => { this.openModal(id); }}>
              <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
            </LinkLikeButton>
        }
      </RoleConfigFilter>
      <RoleConfigFilter permissions={['references#2']}>
        <UrlWrappedLink url={`/references/${ref.refPath}/${id}`} id={`edit_${id}`}>
          <img
            src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
          />
        </UrlWrappedLink>
      </RoleConfigFilter>
    </div>);
  }

  render() {
    return this.state.refs ?
      <div className="dict">
        <MainComponentBox wide>
          <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
            <Modal.Body>
              Are you sure you want to delete this element?
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.yesButton} id="delete_yes">Yes</Button>
              <Button onClick={this.closeModal} id="delete_no">No</Button>
            </Modal.Footer>
          </Modal>
          <Col
            xs={12}
            id="dictTable"
            className={'references-list'}
          >
            <div>
              <ReactBootstrapTableRemotePagination
                data={this.state.refs}
                striped
                hover
                bordered={false}
                condensed
                pagination={this.state.refs.length > 100}
                options={$.extend({ defaultSortName: 'name', defaultSortOrder: 'asc' },
                  TableOptions)}
              >
                {this.getNameColumn()}
                <TableHeaderColumn
                  width="107"
                  searchable={false}
                  className={'references-audit-header'}
                >
                  <AvailableSince version={VERSIONS.VasyaFinal}>
                    <RoleConfigFilter permissions={['audit']}>
                      <Audit
                        entityType="reference"
                        title={`${this.name} audit`}
                        module={`dict/${this.refPath}`}
                        entityId=""
                      >
                        <img src={audit} className={'audit-icon'} alt={'Audit'} />
                        AUDIT
                      </Audit>
                    </RoleConfigFilter>
                  </AvailableSince>
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="112"
                  searchable={false}
                  columnClassName={'payments-pre-last-columns'}
                  className={'references-add-header payments-pre-last-columns-header'}
                >
                  {this.showAddButton() ?
                    <Button
                      id="addNew"
                      bsStyle="primary"
                      onClick={() => navTo(`/references/${this.refPath}/new`)}
                    >
                      Add
                    </Button>
                    :
                    ''
                  }
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="112"
                  dataFormat={this.renderModificationButtons} searchable={false}
                  dataField="id"
                  isKey
                  className={'payments-last-columns-header'}
                  columnClassName={'payments-last-columns'}
                />
              </ReactBootstrapTableRemotePagination>
            </div>
          </Col>
        </MainComponentBox>
      </div>
      : <div></div>;
  }
}

List.propTypes = {
  refs: React.PropTypes.object,
  deleteRef: React.PropTypes.func,
  restore: React.PropTypes.func,
};
